import styled from 'styled-components';
import { Header } from '../../components/ReportsSetup/ReportsSetup.styles';
import SearchBox from '../../components/SearchBox/SearchBox';
import { LabelRegularBoldM } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const Container = styled.div`
  display: flex;
`;

export const TableHeaderCont = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: center;

  ${({ theme }) => `
    margin: ${theme.layout.spacing.centy} 0 0;
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.tera};
    gap: ${theme.layout.spacing.mikro};
  `}
`;

export const Column = styled(LabelRegularBoldM)`
  display: block;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const ReportColumn = styled(Column)`
  width: 20%;
`;

export const AccessColumn = styled(Column)`
  width: 65%;
`;

export const ResponseRateColumn = styled(Column)`
  width: 15%;
`;

export const TableBody = styled.div`
  position: relative;
  min-height: calc(100vh - 440px);
  max-height: calc(100vh - 440px);
  overflow: auto;
  padding-bottom: 2px;

  ${({ theme }: IThemeProvider) => `
      margin:  0 0 ${theme.layout.spacing.decy} 0;
   `}
`;

export const Tile = styled.div`
  position: relative;
  min-height: 50px;
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: flex-end;
  box-sizing: border-box;

  ${({ theme }) => `
    margin: ${theme.layout.spacing.mili} ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 0;
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.tera};
    gap: ${theme.layout.spacing.mikro};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
  `};
`;

export const ReportCell = styled.div`
  width: 20%;
`;

export const AccessCell = styled.div`
  width: 65%;
  display: flex;
  justify-content: space-between;
  padding-right: 48px;
  max-height: 34px;
  overflow: hidden;

  ${({ theme }) => `
    svg {
      cursor: pointer;
      margin: auto 0 auto 10px;
      min-width: 16px;
      min-height: 16px;

      path {
        fill: ${theme.colors.neutral.primary[80]};
      }

      &:hover {
        width: 18px;
        height: 18px;

        path {
          fill: black;
        }
      }
    }
  `};
`;

export const ResponseRateCell = styled.div`
  width: 15%;
`;

export const ResponseRateContainer = styled.div`
  width: 120px;
`;

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
      margin: 0;
   `}
`;

export const NoAccess = styled.div`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.support.red[100]};
  `};
`;

export const ResultsSearchBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  input {
    width: 224px;
  }
`;

export const ShareResultsHeader = styled(Header)`
  height: auto;
  border-top: none;
  margin: 0 0 24px;
  padding-bottom: 12px;
`;
